/* eslint-disable @reatom/unit-naming-rule */
import { action } from '@reatom/framework'

import {
  openTradeSettingsDialogEvent,
  tradeSettingsAtom,
} from '@root/features/trade/trade-settings'

export const reatomWalletSwapSettings = () => {
  const openSettingsAction = action((ctx) => {
    openTradeSettingsDialogEvent(ctx, {})
  }, 'reatomSwapSettings.openSettingsAction')

  return {
    swapSettingsAtom: tradeSettingsAtom,
    openSettingsAction,
  }
}
export type WalletSwapSettingsModel = ReturnType<
  typeof reatomWalletSwapSettings
>
